var _rect, _polygon, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 200",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 200,
    fill: "#022588",
    rx: 10,
    ry: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,100 150,150 250,100 150,50",
    fill: "purple"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 100,
    r: 40,
    fill: "green"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardback);
export default __webpack_public_path__ + "static/media/cardback.ac7ea92d31010c9dc49fe8d64372de7e.svg";
export { ForwardRef as ReactComponent };